export default __webpack_public_path__ + "static/media/edit_sign.9eb0f578.svg";